import { Skeleton } from '@shared/components/shadcn';

function JackpotSkeleton() {
  return (
    <div className="ll-grid-container items-center gap-y-6">
      <div className="ll-container-inner flex flex-col items-stretch gap-y-6">
        <div className="flex flex-col gap-1 justify-center items-center">
          <Skeleton className="h-14 w-60 rounded-md" />
          <Skeleton className="h-8 w-50 rounded-md" />
        </div>
        <div className="grid grid-cols-1 gap-y-6 content-stretch items-center xs:grid-cols-2 xs:gap-x-3 md:grid-cols-[repeat(3,auto)]">
          <div className="flex flex-col gap-1 items-center grow">
            <Skeleton className="h-5 w-20 rounded-md" />
            <Skeleton className="h-13 w-full rounded-full" />
          </div>
          <div className="flex flex-col gap-1 items-center grow row-span-1 row-start-1 col-span-full md:col-span-1 md:col-start-2">
            <Skeleton className="h-5 w-20 rounded-md" />
            <Skeleton className="h-15 w-full rounded-full" />
          </div>
          <div className="flex flex-col gap-1 items-center grow">
            <Skeleton className="h-5 w-20 rounded-md" />
            <Skeleton className="h-13 w-full rounded-full" />
          </div>
        </div>
        <div className="ll-container-full flex flex-col items-center">
          <Skeleton className="h-6 w-80 rounded-md" />
          <div className="flex gap-x-3 overflow-hidden my-6">
            {Array.from({ length: 20 }).map((_, index) => (
              <Skeleton key={index} className="h-62.5 w-60 rounded-md" />
            ))}
          </div>
          <Skeleton className="h-8 w-30 rounded-full" />
        </div>
      </div>
    </div>
  );
}

export { JackpotSkeleton };
